"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: #fff;\n\tpadding: 0;\n\tmargin: 0;\n\twidth: 100%;\n\toverflow-y: auto;\n\tdisplay: ", ";\n\n\t@media screen and (min-width: ", ") {\n\t\tborder: 1px solid ", ";\n\t\tborder-radius: ", ";\n\t\tmax-height: ", ";\n\t\tbox-shadow: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Options = _styledComponents.default.ul(_templateObject(), function (props) {
  return props.open ? 'block' : 'none';
}, _breakpoints.default.tablet, _colors.default.borderColor, _vars.default.borderRadius, function (props) {
  return props.density === 'expanded' ? '320px' : '240px';
}, _vars.default.boxShadow);

Options.displayName = 'Options';
var _default = Options;
exports.default = _default;